import { createContext } from 'react'

const ConstantsContext = createContext({
  sections: {
    style: 'Stil',
    character: 'Bogstav',
    scale: 'Bogstav størrelse',
    color: 'Farve',
    personalisedText: 'Navn',
    personalisedText2: 'Undertekst',
    layout: 'Layout',
    size: 'Plakat størrelse',
    frame: 'Ramme',
    invert: 'Flip farver',
  },
  groups: {
    character: 'Bogstav',
    'style-layout': 'Stil',
    'color-size': 'Farve & størrelse',
    'personalised-text': 'Navn & undertekst',
    'poster-finish': 'Plakat størrelse',
    frame: 'Ramme',
  },
})

export default ConstantsContext
